module.exports = __webpack_public_path__ + "media/src/img/payment/image4-7e9acded652e1dcfb3fa92f202ce1363.png";